import { getScoreTypeList } from "@/services/score-type.service";
import { setPaginationDetails } from "@/utils/utils";

// initial state
const state = () => ({
  scoreTypeList: [],
});

// mutations
const mutations = {
  setScoreTypeList(state, data) {
    state.scoreTypeList = data;
  },
};

// actions
const actions = {
  async loadScoringTypeList(vuexContext, co) {
    return await getScoreTypeList(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      items.map((item, index) => {
        item.index = index + 1;
        item.text = item.name;
        item.value = item.id;
      });

      setPaginationDetails(co, totalCount, totalPages);

      //   if (co.withoutPagination === undefined) {
      //     vuexContext.rootState.pagination.totalRecords = totalCount;
      //     vuexContext.rootState.pagination.totalPages = totalPages;
      //   }
      vuexContext.commit("setScoreTypeList", items);
      return items;
    });
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
